import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
    createCriteria(rootState, templateId, newCriteria, position, callbacks)   {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La création du critère a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "label": newCriteria.label,
            "position": position
        })});

        Vue.axios.post(rootState.baseUrl + "/admin/template/" + templateId + "/criteria/create", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    updateCriteria(rootState, templateId, newCriteria, position, callbacks)   {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La mise à jour du critère a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "label": newCriteria.label,
            "position": position
        })});

        Vue.axios.post(rootState.baseUrl + "/admin/template/" + templateId + "/criteria/update/" + newCriteria.id, params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    deleteCriteria(rootState, criteriaId, callbacks)	{
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La suppression du critère a échoué.",
                type: 'danger'
            });
        };

	    Vue.axios.delete(rootState.baseUrl + "/admin/criteria/delete/" + criteriaId, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success();
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    setCriteriaAnswer(rootState, instanceId, selectedAnswer, nextCriteriaPosition, nextStep, nextPatient, currentPatient, currentStep, callbacks) {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La sauvegarde de la réponse a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "choice": selectedAnswer,
            "nextCriteriaPosition": nextCriteriaPosition,
            "nextStep": nextStep,
            "nextAnswerPatientNumber": nextPatient,
            "currentPatientNumber": currentPatient,
            "currentStep": currentStep
        })});

        Vue.axios.post(rootState.baseUrl + "/user/instance/" + instanceId + "/set-criteria-answer", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    }
};